import TripDetailsContainer from 'containers/customerAccounts/TripDetails/index'
import React from 'react'


const TripDetailsPage = () => {

  return (
    <div><TripDetailsContainer/></div>
  )
}

export default TripDetailsPage